import { createContext, useContext } from 'react';
import { IDndItemEditor } from './useDndEditor';

export interface DndEditorContext {
  editor: IDndItemEditor;
}

export const DndEditorContext = createContext<DndEditorContext>({
  editor: {} as any,
});

export function useDndEditorContext(): IDndItemEditor {
  const { editor } = useContext(DndEditorContext);
  return editor;
}
